export default __webpack_public_path__ + "static/the-heartfulness-dasara-event-c46f4e0a6145639139c0af444de7fb74.png";